import { combineReducers } from "redux";

import { loginReducer } from "./Login/LoginReducer";
import { selectScheduleReducer } from "./SelectSchedule/SelectScheduleReducer";
import  fullCalendarReducer  from "../redux-toolkit/FullCalendar/FullCalendar"
import  incomingCallReducer  from "../redux-toolkit/TwilioIncomingCall/TwilioIncomingCall"
import  shiftListSliderReducer  from "../redux-toolkit/shift-list-slider/shift-list-slider"
import NotificationFilterReducer from "../redux-toolkit/NotificationFilter/NotificationFilter"

const rootReducer = combineReducers({
  loginReducer,
  selectScheduleReducer,
  NotificationFilterReducer,
  fullCalendarReducer,
  incomingCallReducer,
  shiftListSlider:shiftListSliderReducer,
});

export default rootReducer;
